import React, { useLayoutEffect, Component } from "react"
import { graphql } from "gatsby"
import parse from "html-react-parser"
import StructuredText from "../custom-structured-text-renderer"
import { Asset, Link } from "../../../../plugins/gatsby-plugin-atollon"
import { RightArrow } from "../../icons"
import { gsap } from "gsap"
import { ScrollTrigger } from "gsap/ScrollTrigger"

class BlockUpdate extends Component {
  shouldComponentUpdate() {
    return false
  }
  render() {
    return (<>{ this.props.children }</>)
  }
}

gsap.registerPlugin(ScrollTrigger)

const TitleContentListImage = ({ title, richContent, images, list }) => {
  useLayoutEffect(() => {
    let sections = gsap.utils.toArray(".title-content-list-image__item")

    if (sections?.length === 0) return
    let ns = Math.random().toString(36).substring(7)

    let xPercent = (-100 * (sections.length - 1) - 15)
    // if window width > 900 
    if (window.innerWidth > 900) {
      xPercent = (-100 * (sections.length - 1) + 25)
    }
    if (window.innerWidth > 1400) {
      xPercent = (-100 * (sections.length - 1.5) + 25)
    }
    if (window.innerWidth > 1800) {
      xPercent = (-100 * (sections.length - 1.75) + 25)
    }
    if (window.innerWidth > 2100) {
      xPercent = (-100 * (sections.length - 2) + 25)
    }
    let timeline = gsap.to(sections, {
      xPercent: xPercent,
      ease: "none",
      scrollTrigger: {
        id: `${ns}-title`,
        trigger: ".title-content-list-image",
        pin: true,
        scrub: 1,
        start: "bottom bottom",
      },
    })
    return () => {
      const titleElTrigger = ScrollTrigger.getById(`${ns}-title`)

      if (titleElTrigger) {
        titleElTrigger.kill()
      }
    }
  }, [])

  return (
    <BlockUpdate>
      <section className="title-content-list-image">
        <div className="title-content-list-image__inner">
          {title && <h2>{parse(title)}</h2>}

          <div className="title-content-list-image__wrapper">
            <div className="title-content-list-image__info" data-sal="slide-up" data-sal-duration="1000"
                data-sal-easing="ease">
              {richContent && <StructuredText data={richContent} />}

              <div className="title-content-list-image__list">
                {list?.length > 0 && list.map((el, i) => (
                  <Link key={i}
                        to={el.link[0].externalLink ? el.link[0].externalLink : el.link[0].internalLink?.permalink}>{el.title}
                    <RightArrow color="#0D2E7A" /></Link>
                ))}
              </div>
            </div>
            <div className="title-content-list-image__items">
              {images?.length > 0 && images.map((el, i) => (
                <div key={i} className="title-content-list-image__item">
                  <Asset asset={el} />
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </BlockUpdate>
  )
}

export default TitleContentListImage

export const query = graphql`
fragment TitleContentListImageProps on DatoCmsTitleContentListImage {
  ... on DatoCmsTitleContentListImage {
    id
    title
    images {
      ...InternalAssetProps
    }
    richContent {
      value
    }
    list {
      ...LinkWithTitleProps
    }
  }
}
`

